import { ArrowLeft } from "lucide-react";
import { Button } from "../../../../components/button";
import { ErrorPlaceholder, PageHeader } from "../../../../components/common";

interface ProgramEditorErrorStateProps {
  subtitle: string;
  title: string;
  description: string;
  error: string;
  onRetry: () => void;
  onBack: () => void;
}

export function ProgramEditorErrorState({
  subtitle,
  title,
  description,
  error,
  onRetry,
  onBack,
}: ProgramEditorErrorStateProps) {
  return (
    <div className="min-h-full bg-[linear-gradient(180deg,#F7FBF9_0%,#FFFFFF_22%)] px-6 py-6">
      <div className="mx-auto max-w-7xl space-y-6">
        <PageHeader
          title="Program Editor"
          subtitle={subtitle}
          sticky
          actions={
            <Button variant="brand-outline" onClick={onBack}>
              <ArrowLeft className="h-4 w-4" />
              Back to Campaigns
            </Button>
          }
        />
        <ErrorPlaceholder
          title={title}
          description={description}
          error={error}
          onRetry={onRetry}
        />
      </div>
    </div>
  );
}
